import sanitizeHtml from 'sanitize-html';

// Imported synchronously on purpose: a lazy `import('sanitize-html')` left
// sanitize() as an identity pass-through until the chunk resolved, opening an
// XSS window where user HTML reached v-html unsanitized during initial render.
export default function sanitize(html: string): string {
  return sanitizeHtml(html);
}
